module.exports = __webpack_public_path__ + "static/media/loading.182d1236.gif";